import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { ICourseFilters } from '../models/components/user-home_my_courses';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('MainMenu-Service');

export class UserHomeService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetUserCalendarActivitiesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/calendar/my', params, '', true).then((responseData: Response) => {
            if (responseData.status !== 200) {
                return responseData;
            } else {
                return responseData.json();
            }
        }).then((result: any) => {
            return result;
        }).catch((response: any) => {
            Notification.setNotification('error', T.t('r_user_home_calendar_error_message'), 'topRight');
            return response;
        });
    }

    public async RequestGetMyCoursesAsync(teacher: boolean, searchText: string | undefined, filters?: ICourseFilters| undefined ) {
        const filterParams : ICourseFilters = {
            termId: filters!.termId ?? null,
            programId: filters!.programId ?? null,
            status: filters!.status ?? 1,
            sourceCourseId: filters!.sourceCourseId ?? '',
            masterCourseId: filters!.masterCourseId ?? '',
            searchProgId: filters!.searchProgId ?? null,
            searchTermId: filters!.searchTermId ?? null,
            searchCourseName: filters!.searchCourseName ?? '',
            courseId: filters!.courseId ?? ''
        }
        const teacherParamsModel = {
            apiUrl: 'api/course/teachercourses',
            withFilter:{
                Status: filterParams.status, // Teacher= Verdiğim dersler 
                searchText: searchText ?? '',
                Take: 1000,
                Skip: 0,      
                SearchTermId: filterParams.searchTermId,
                SearchProgId: filterParams.searchProgId,
                SearchCourseName: filterParams.searchCourseName,
                SourceCourseId: filterParams.sourceCourseId,
                MasterCourseId:filterParams.masterCourseId,
                CourseId: filterParams.courseId 
            },
            default:{
                Status: 1, // Teacher= Verdiğim dersler 
                searchText: searchText ?? '',
                Take: 1000,
                Skip: 0,  
            }
        };
        const studentParamsModel = {
            apiUrl: 'api/course/enrolledcourses',
            withFilter:{
                Take: 1000,
                Skip: 0,
                SearchCourseName: filterParams.searchCourseName,
                ActiveStatus: filterParams.status ,// Student = Devam eden dersler
                CourseDateFilter: 4, // all
                isNotifications: true,
                SearchTermId: filterParams.searchTermId,
                SearchProgId: filterParams.searchProgId,
                SourceCourseId: filterParams.sourceCourseId,
                MasterCourseId: filterParams.masterCourseId,
                CourseId: filterParams.courseId
            },
            default:{
                Take: 1000,
                Skip: 0,
                ActiveStatus: 1,// Student = Devam eden dersler
                CourseDateFilter: 4, //all
                isNotifications: true,
            }
            
        }
        const params = teacher ? teacherParamsModel : studentParamsModel;

        return _apiClient.RequestAsync('POST', params.apiUrl, filters ? params.withFilter : params.default, token).then((responseData: Response) => {
            if (responseData.status !== 200) {
                Notification.setNotification('error', T.t('r_my_user_my_courses_error_mesage'), 'topRight');
            }
            return responseData;
        }).then((result: any) => {
            return result.json();
        }).catch((response) => {
            Notification.setNotification('error', T.t('r_my_user_my_courses_error_mesage'), 'topRight');
            return response;
        });
    }

    public async RequestGetUpcomingActivitiesAsync(params?: any) {
        const {
            Take = 5,
            Skip = 0,
            Hour = 24,
            ClassId = 0,
            CourseId = 0
        } = params || {};

        return  _apiClient.RequestAsync('POST', 'api/course/upcomingActivities', {
            take: Take,
            skip: Skip,
            hour: Hour,
            classId: ClassId,
            courseId: CourseId
        }).then((result: any) => {
            return result.json();
        }).catch((response) => {
            return response;
        });
    }

}